import { config, library, dom } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf, faFileWord, faMugHot } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faHtml5 } from '@fortawesome/free-brands-svg-icons';

config.mutateApproach = 'sync'

library.add(faGithub, faHtml5, faFilePdf, faFileWord, faMugHot);

dom.watch()